import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./pages/Login";
import AutoCreateLider from "./pages/AutoCreateLider";
import Formulario from "./pages/Formulario";
import Menu from "./pages/Menu";
import AdminLogin from "./pages/AdminLogin";
import AdminMenu from "./pages/AdminMenu";
import AdminEventos from "./pages/AdminEventos";
import Inicio from "./pages/Inicio";
import Eventos from "./pages/Eventos";
import PrivateRoute from "./components/PrivateRoute";
import AdminRoute from "./components/AdminRoute";
import AuditoriaLogin from "./pages/AuditoriaLogin";
import Auditoria from "./pages/Auditoria";
import AdminNiveles from "./pages/AdminNiveles";
import AdminParticipantes from "./pages/AdminParticipantes";
import AdminLideres from "./pages/AdminLideres";
import AdminAuditoria from "./pages/AdminAuditoria";
import EstructuraNiveles from "./pages/EstructuraNiveles";
import LoginEventoMasivo from "./pages/LoginEventoMasivo";
import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EventosMasivos from "./pages/EventosMasivos";
import ConsultaEventosMasivos from "./pages/ConsultaEventosMasivos";


function App() {
  return (
    <Router>
      {/* ToastContainer debe estar aquí, dentro del Router pero fuera de Routes */}
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} closeOnClick pauseOnHover draggable />
      <Routes>

        {/* Rutas públicas */}
        <Route path="/" element={<Inicio />} />
        <Route path="/AdminLogin" element={<AdminLogin />} />
        <Route path="/AuditoriaLogin" element={<AuditoriaLogin />} />
        <Route path="/Usuario" element={<Login />} />
        <Route path="/LoginEventoMasivo" element={<LoginEventoMasivo />} />

        {/* Rutas protegidas para líderes */}
        <Route element={<PrivateRoute />}>
          <Route path="/menu" element={<Menu />} />
          <Route path="/formulario" element={<Formulario />} />
          <Route path="/Eventos" element={<Eventos />} />
        </Route>

        {/* Rutas protegidas para administradores */}
        <Route element={<AdminRoute />}>
          <Route path="/admin/menu" element={<AdminMenu />} />
          <Route path="/adminEventos" element={<AdminEventos />} />
          <Route path="/autocreate" element={<AutoCreateLider />} />
          <Route path="/auditoria" element={<Auditoria />} />
          <Route path="/adminNiveles" element={<AdminNiveles />} />
          <Route path="/adminparticipantes" element={<AdminParticipantes />} />
          <Route path="/adminLideres" element={<AdminLideres />} />
          <Route path="/adminAuditoria" element={<AdminAuditoria />} />
          <Route path="/estructuraNiveles" element={<EstructuraNiveles />} />
          <Route path="/EventosMasivos" element={<EventosMasivos />} />
          <Route path="/ConsultaEventosMasivos" element={<ConsultaEventosMasivos />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
